import { Navigate, Outlet } from 'react-router-dom';

import { FeatureFlag, useFlag } from './feature-flags';

/**
 * Hiding a sidebar entry leaves its URL resolvable, so a bookmarked link would
 * still reach a page the gate is meant to hold back. Redirects to `to` instead.
 */
export const FlagGuard = ({ flag, to }: { flag: FeatureFlag; to: string }) =>
  useFlag(flag) ? <Outlet /> : <Navigate to={to} replace />;
